import {BaseApiRequestParams} from "../../infrastructure/models/params/base-api-request-params";

export class AthleteGameLineupsRequestParams extends BaseApiRequestParams {

  constructor(athleteId: Number, gameId: Number, matchWeekKey: String) {
    super('athletes/games/lineups');

    this.athleteId = athleteId;
    this.gameId = gameId;
    this.matchWeekKey = matchWeekKey;
  }

  get athleteParam() {
    return this.athleteId > 0  ? `&athleteId=${this.athleteId}` : '';
  }

  get gameParam() {
    return this.gameId > 0  ? `&gameId=${this.gameId}` : '';
  }

  get matchWeekKeyParam() {
    return this.matchWeekKey ? `&matchWeekKey=${this.matchWeekKey}` : '';
  }


  toString(): String {
    return super.toString() + this.athleteParam + this.gameParam + this.matchWeekKeyParam;
  }

  equals(model: AthleteGameLineupsRequestParams): * {
    let equals = super.equals(model);

    equals &= this.athleteParam === model.athleteParam;
    equals &= this.gameParam === model.gameParam;
    equals &= this.matchWeekKeyParam === model.matchWeekKeyParam;

    return equals;
  }
}